// @ts-nocheck
// Sola uses exact this metric to track booking
export function trackBookForSola() {
  if (window.gtag) {
    window.gtag('event', 'appointment-booked', {
      event_category: 'client-web',
    });
  }
}

export function trackBookSuccess(id) {
  if (window.gtag) {
    window.gtag('event', 'book-success', {
      event_category: 'web-booking',
      event_label: String(id),
    });
  }
}

export function trackBookFail() {
  if (window.gtag) {
    window.gtag('event', 'book-fail', {
      event_category: 'web-booking',
    });
  }
}

export function trackBookSuccessForOldVersion(id) {
  if (window.gtag) {
    window.gtag('event', 'book-success', {
      event_category: 'web-booking-old',
      event_label: String(id),
    });
  }
}

export function trackBookFailForOldVersion() {
  if (window.gtag) {
    window.gtag('event', 'book-fail', {
      event_category: 'web-booking-old',
    });
  }
}
